import { useCallback } from 'react'
import ApiService from '../../../services/ApiService'
import { showAlert } from '../../../utility/SweetAlert'
import { useTranslation } from 'react-i18next'

const InteractorOrderView = () => {
  const { t } = useTranslation()
  const orderView = useCallback(
    (payload, callback, loading) => {
      ApiService.jsonRequest('/transaction-order/search', payload, (response) => {
        if (response.status_code === 200) {
          if (response.data) {
            callback(response.data)
          } else {
            showAlert({
              icon: 'warning',
              message: t('response_message.send_failed'),
              timer: 2000,
              reload: true,
            })
          }
        }
        loading(false)
      })
    },
    [t],
  )
  return { orderView }
}

export default InteractorOrderView
